// externals
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

// libraries
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as tradeInSelectors from '@makemydeal/dr-dash-store/selectors/trade';
import * as accessoriesSelectors from '@makemydeal/dr-dash-store/selectors/accessoriesSelectors';
import * as dealXgDetailsSelectors from '@makemydeal/dr-dash-store/selectors/dealXgDetailsSelectors';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';
import { ACTIVITY_NAME_ACCESSORIES } from '@makemydeal/dr-dpm-client';
import type { StateTree } from '@makemydeal/dr-dash-types';

// components
import DealActivityCard from '../DealActivityCard.interstate';

const name = 'accessories';

const AccessoriesCard = () => {
    const dispatch = useDispatch();
    const incentivesCompleted = useSelector(offerReduxSelectors.getAppliedIncentivesForNonDealerCash).length > 0;
    const tradeCompleted = useSelector(tradeInSelectors.isTradeInCompleted);
    const isAccessoriesCompleted = useSelector(accessoriesSelectors.getAccessoriesList).length > 0;
    const isAccessoriesFormOpen = useSelector(accessoriesSelectors.getFormStatus);
    const totalAccessoriesAmount = useSelector(accessoriesSelectors.getAccessoriesTotalAmount);
    const cardValue = formatDollarsAndCents(totalAccessoriesAmount);
    const isCardRecommended = !isAccessoriesCompleted && incentivesCompleted && tradeCompleted && !isAccessoriesFormOpen;

    const accessoriesDpmState = useSelector((state: StateTree) =>
        dealXgDetailsSelectors.getDpmStateByActivity(state, ACTIVITY_NAME_ACCESSORIES)
    );

    const handleCardClick = () => {
        // Dispatch analytics action
        if (isAccessoriesCompleted) {
            dispatch(interactionAnalyticsActionCreators.vehicleAccessoriesEditLink());
        } else {
            dispatch(interactionAnalyticsActionCreators.vehicleAccessoriesStartLink());
        }

        dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.Accessories));
    };

    return (
        <DealActivityCard
            dpmState={accessoriesDpmState}
            name={name}
            showCardAnchor={true}
            cardValue={cardValue}
            completed={isAccessoriesCompleted}
            recommended={isCardRecommended}
            action={handleCardClick}
        />
    );
};

export default AccessoriesCard;
